import { Config } from 'config';

export const getImageSrc = (imageId: string, width?: number) =>
  `${Config.REACT_APP_LAUNCHPAD_BASE_URL}storage/files/${imageId}${
    width ? `?q=75&w=${width}` : ''
  }`;
